
import Cookies from 'js-cookie'
import api from '../api/auth.js'

const USER_DATA_KEY = 'user_data_key'

const user = {
  userId: null,
  userData: null
}

user.set = function(v) {
  this.userId = v.userId
  this.userData = v
}

user.save = function(value) {
  if (value) {
    this.userData = value
    this.userId = value.id
    Cookies.set(USER_DATA_KEY, JSON.stringify(value))
  }
}

user.clean = function() {
  this.userId = null
  this.userData = null
  Cookies.remove(USER_DATA_KEY)
}

user.getUserData = function() {
  if (this.userData) {
    return this.userData
  }
  const u = Cookies.get(USER_DATA_KEY)
  if (u) {
    return JSON.parse(Cookies.get(USER_DATA_KEY))
  }

  return null
}

user.updateUser = function() {
  const that = this
  api.userInfo().then(r => {
    that.save(r.data)
  })
}

export default user
